import createIcon from '../../createIcon';

/**
 * @component @name CurrencyFranc
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTguNSA1VjNINy41VjE2SDUuNVYxOEg3LjVWMjFIOS41VjE4SDEzLjVWMTZIOS41VjEzSDE3LjVWMTFIOS41VjVIMTguNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CurrencyFranc = createIcon('CurrencyFranc', [
  [
    'path',
    {
      d: 'M18.5 5V3H7.5V16H5.5V18H7.5V21H9.5V18H13.5V16H9.5V13H17.5V11H9.5V5H18.5Z',
      key: 'vrtlo7',
    },
  ],
]);

export default CurrencyFranc;
